// แปลง writer ปัจจุบันและข้อมูล legacy ให้เป็นจำนวนเงินบุตรแบบ primitive โดยรับ number, numeric string และ object.amount ที่เป็นค่าบวกเท่านั้น
const normalizeChildDeductionAmount = (value) => {
  const rawAmount =
    value && typeof value === "object" && !Array.isArray(value)
      ? value.amount
      : value;

  if (typeof rawAmount === "number") {
    return Number.isFinite(rawAmount) && rawAmount > 0 ? rawAmount : null;
  }

  if (typeof rawAmount !== "string" || rawAmount.trim() === "") {
    return null;
  }

  const normalizedAmount = Number(rawAmount);
  return Number.isFinite(normalizedAmount) && normalizedAmount > 0
    ? normalizedAmount
    : null;
};

// ทำให้รายการบุตรจาก writer หรือ Storage เก่าเป็น primitive numbers และตัดแถวผิดรูปแบบก่อนสร้างยอดหรือ mirror
export const normalizeChildDeductionList = (chlidList) => {
  if (!Array.isArray(chlidList)) {
    return [];
  }

  return chlidList.reduce((result, row) => {
    const amount = normalizeChildDeductionAmount(row);
    if (amount !== null) {
      result.push(amount);
    }
    return result;
  }, []);
};

// เก็บ snapshot ของค่าลดหย่อนบุตรก่อนเปิด drawer โดยแยกรายการออกจาก state เดิมเพื่อไม่ให้ draft แก้ snapshot ตามไปด้วย
export const createChildDeductionSnapshot = (state) => {
  return {
    chlidList: normalizeChildDeductionList(state?.chlidList),
    deduct_child: state?.deduct_child ?? 0,
    deduct_child_prev: state?.deduct_child_prev ?? 0,
    ishasChild: Boolean(state?.ishasChild),
  };
};

// เปิด session ใหม่เฉพาะขอบ false -> true เพื่อให้ Cancel ใช้ snapshot รอบปัจจุบัน และการเปลี่ยน draft ระหว่างเปิดไม่ทับ snapshot นั้น
export const transitionChildDeductionDrawerSession = (
  session,
  isOpen,
  currentState
) => {
  const normalizedIsOpen = Boolean(isOpen);
  const previousIsOpen = Boolean(session?.isOpen);
  const isOpening = !previousIsOpen && normalizedIsOpen;

  return {
    isOpen: normalizedIsOpen,
    snapshot: isOpening
      ? createChildDeductionSnapshot(currentState)
      : session?.snapshot || null,
  };
};

// รวมยอดจากรายการบุตรที่เป็นตัวเลขจริงเท่านั้น เพื่อให้ state mirror ทุกตัวใช้ยอดเดียวกัน
const calculateChildDeductionAmount = (chlidList) => {
  return chlidList.reduce((sum, amount) => sum + amount, 0);
};

// ยืนยันรายการบุตรเป็น state ชุดเดียว โดย current, previous และ has-child ต้องสอดคล้องกับ list เสมอ
export const confirmChildDeductionState = (state) => {
  const chlidList = normalizeChildDeductionList(state?.chlidList);
  const childDeductionAmount = calculateChildDeductionAmount(chlidList);

  return {
    chlidList,
    deduct_child: childDeductionAmount,
    deduct_child_prev: childDeductionAmount,
    ishasChild: chlidList.length > 0,
  };
};

// ลบบุตรตามตำแหน่งแล้วสร้าง state ชุดใหม่ เพื่อให้การลบคนสุดท้าย clear list, ยอดปัจจุบัน, ยอดก่อนหน้า และ flag พร้อมกัน
export const deleteChildDeductionAt = (state, index) => {
  const chlidList = normalizeChildDeductionList(state?.chlidList);

  if (Number.isInteger(index) && index >= 0 && index < chlidList.length) {
    chlidList.splice(index, 1);
  }

  return confirmChildDeductionState({ chlidList });
};

// แทนรายการสรุปลูกเดิมด้วยยอดจาก family owner เพียงรายการเดียว และลบทิ้งเมื่อไม่เหลือข้อมูลที่ใช้ได้
export const replaceChildDeductionSummary = (deduction, state) => {
  const confirmedState = confirmChildDeductionState(state);
  const nextDeduction = (Array.isArray(deduction) ? deduction : []).filter(
    (row) => row?.key !== "deduct_child" && row?.title !== "ลูก"
  );

  if (!confirmedState.ishasChild) {
    return nextDeduction;
  }

  return [
    ...nextDeduction,
    {
      title: "ลูก",
      amount: confirmedState.deduct_child,
      key: "deduct_child",
    },
  ];
};

// สร้าง form หลัง child transition จาก form ล่าสุด แล้วคำนวณรายการและยอดสรุปทั้งสามใน updater เดียวกัน
export const createChildDeductionFormState = (
  form,
  childState,
  generateSummary
) => {
  const childForm = {
    ...form,
    deduct_child: childState.deduct_child,
    deduct_child_prev: childState.deduct_child_prev,
  };
  const {
    result,
    sumResult,
    sumResultExceptEducationDonate,
    sumResultExceptOtherDonate,
  } = generateSummary(childForm);

  return {
    ...childForm,
    deduction_first: result,
    deduct_summary: sumResult,
    deduct_summary_except_education_donate: sumResultExceptEducationDonate,
    deduct_summary_except_other_donate: sumResultExceptOtherDonate,
  };
};

// ยกเลิก draft ด้วย snapshot ก่อนเปิด drawer โดย clone list อีกครั้งเพื่อไม่ให้ state หลัง restore แชร์ reference กับ snapshot
export const restoreChildDeductionSnapshot = (snapshot) => {
  return createChildDeductionSnapshot(snapshot);
};
